import { useState } from "react";
import { CompactPicker } from "react-color";
import OutsideClickHandler from "react-outside-click-handler";
import { useSelector } from "react-redux";
import { useAddTeamMutation } from "../../features/team/teamApi";

export default function TeamModal({ close, state }) {
    const [category, setCategory] = useState("");
    const [description, setDescription] = useState("");
    const [color, setColor] = useState("");

    // get user data
    const { user } = useSelector((state) => state.auth);

    // add team api
    const [addTeamApi] = useAddTeamMutation();

    // add team submit handler
    const submitAddTeam = (e) => {
        e.preventDefault();
        if (category !== "" && description !== "" && color !== "") {
            addTeamApi({
                category,
                description,
                color,
                admin: user?.email,
                members: [user?.email],
                date: new Date().getTime(),
            });
            state(false);
        } else {
            alert("Form inputs is required!");
        }
    };

    return (
        <>
            <div className="fixed inset-0 backdrop-blur-sm ml-0">
                <OutsideClickHandler onOutsideClick={() => close()}>
                    <div className="w-6/12 rounded bg-white p-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <h4 className="text-2xl font-bold pb-10">
                            Create Team.
                        </h4>
                        <form onSubmit={submitAddTeam}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="h-10 w-full border px-3 text-sm focus:outline-none rounded border-[#FF5733]"
                                    placeholder="Title"
                                    required
                                    onChange={(e) =>
                                        setCategory(e.target.value)
                                    }
                                    value={category}
                                />
                            </div>
                            <div className="mb-3">
                                <textarea
                                    className="h-32 w-full border px-3 pt-2 text-sm focus:outline-none rounded border-[#FF5733]"
                                    placeholder="Description"
                                    required
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                    value={description}
                                />
                            </div>
                            <div className="mb-3 ">
                                <CompactPicker
                                    onChange={(color) => setColor(color.hex)}
                                />
                            </div>
                            <button className="h-10 px-6 text-sm bg-[#FF5733] text-white rounded  duration-200 border-[#FF5733]">
                                Add Team
                            </button>
                        </form>
                    </div>
                </OutsideClickHandler>
            </div>
        </>
    );
}
